// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"575":"fb2b1bc3","656":"46ad7a48","801":"6c2ff6f2","981":"1fc4681e"}[chunkId] + ".chunk.js";
};